// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import utilsModel from "../../../../engines/libs/utilsModel";
import getOneBundle, { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../BundleResourceConfig";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class EnterLayerEventShow2 extends BasePopUpLayer {

    @property(cc.Node)
    nodeContent: cc.Node = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprBg: cc.Sprite = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprPeople: cc.Sprite = null;

    @property({type:cc.Label,displayName:"npc名字"})
    lbName:cc.Label = null;

	@property({ type: cc.RichText, displayName:'' })
	labelChat: cc.RichText = null;

	@property({ type: cc.Label, displayName:'' })
	labelBtnSelect: cc.Label = null;
	@property({ type: cc.Node, displayName:'' })
	btnSelect: cc.Node = null;

    /** 正在显示文本 */
    private bShowTexting: boolean = false;

    start () {
        NormalGameManager._instance.pauseTimer();
        this.initLayer();

        this.addLayerTouchEvent();
    }

    protected onDestroy(): void {
        NormalGameManager._instance.resumeTimer();
    }

    initLayer() {

        this.labelChat.maxWidth = 630;

        this.btnSelect.active = false;

        let peopleName = this._carryData.peopleName;
        let peopleIcon = this._carryData.peopleIcon;
        let btnName = this._carryData.btnName;
        let sprBg = this._carryData.sprBg;
        let descList: string[][] = this._carryData.descList;

        this.lbName.string = peopleName;
        this.labelBtnSelect.string = btnName;

        if (this._carryData.nodeHeight) {
            this.nodeContent.height = this._carryData.nodeHeight;
        }
        let addPeoplePos = this._carryData.addPeoplePos;
        if (addPeoplePos) {
            this.sprPeople.node.x += addPeoplePos.x;
            this.sprPeople.node.y += addPeoplePos.y;
        }

        this.loadPeople(peopleIcon);
        this.showTextAni(descList);
        this.showBg(sprBg);
    }

    /**
     * 加载角色信息
     */
    loadPeople(peopleIcon: string){
        this.sprPeople.node.active = false;
        getOneBundleByInstant(BUNDLE_SMALL_NAME.eventGameBundle).load(`assets/eventHead/${peopleIcon}`,cc.SpriteFrame,(err,spr:cc.SpriteFrame)=>{
            if(err){
                console.error(err,"#87 method loadPeople fail");
                return;
            }
            this.sprPeople.node.active = true;
            this.sprPeople.spriteFrame = spr;
        });
    }

    async showBg(event_bg: string) {
        this.sprBg.node.active = false;
        if (!utilsModel.isValidNumberValue(event_bg)) {
            return;
        }
        
        let bundle = await getOneBundle(BUNDLE_SMALL_NAME.eventGameBundle);
        bundle.load(`assets/EnterLayerEvent/bg/${event_bg}`,cc.SpriteFrame,(err,assets:cc.SpriteFrame)=>{
            if(err){
                console.debug("加载图片失败",err);
                return;
            }
            this.sprBg.node.active = true;
            this.sprBg.spriteFrame = assets;
        });
    }

    /**
     * 选择按钮回调
     * @param event 
     * @param data 
     * @returns 
     */
    onClickSelect(event: cc.Event.EventTouch, data) {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();

        let exitCb = this._carryData.exitCb;
        exitCb && exitCb();
        this.closeLayer();
    }

     /**
     * 显示文本动画
     * @param text 
     */
     async showTextAni(descList: string[][]) {
       
        this.bShowTexting = true;
        this.labelChat.node.stopAllActions();
        this.labelChat.string = '';

        let retText = '';
        let descLen = descList.length;

        for (let i = 0; i < descLen; i++) {
            if (!this.bShowTexting) {
                return;
            }

            let v = descList[i];
            let strText = i == 0 ? '       ' : '';
            let text = v[1];
            let strList = text.split('');
            let idx = 0;
            let length = strList.length;
            await new Promise<void>(resolve=>{
                cc.tween(this.labelChat.node)
                .delay(0.07)
                .call(() => {
                    if (!this.bShowTexting) {
                        this.labelChat.node.stopAllActions();
                        resolve();
                        return;
                    }

                    strText += strList[idx];

                    let rt = ''
                    if (utilsModel.isValidNumberValue(v[0])) {
                        rt = `<color=#${v[0]}>${strText}</c>`;
                    } else {
                        rt = strText;
                    }

                    this.labelChat.string = retText + rt;
                    idx++;

                    if (idx >= length) {
                        retText += rt;
                        if (i >= descLen-1) {
                            this.endTextShow();
                        }
                    }
                })
                .union()
                .repeat(length)
                .call(resolve)
                .start();
            });
            if (!this.bShowTexting) {
                return;
            }
        }
    }

    /**
     * 结束显示文本
     */
    endTextShow() {
        let descList: string[][] = this._carryData.descList;
        let strText = '';
        descList.forEach((v, i)=> {
            let rs = i == 0 ? '       ' : '';
            rs += v[1];
            if (utilsModel.isValidNumberValue(v[0])) {
                strText += `<color=#${v[0]}>${rs}</c>`;
            } else {
                strText += rs;
            }
        });

        this.btnSelect.active = true;
        this.bShowTexting = false;
        // this.labelChat.node.stopAllActions();
        this.labelChat.string = strText;
    }

    
    /**
     * 关闭
     */
    closeLayer() {
        this.destroyNode();

        let exitCb = this._carryData.exitCb;
        if (!exitCb) {
            this._carryData.parent.destroyNode();
        }
    }

    /**
     * 点击屏幕
     * @param event 
     * @returns 
     */
    touchEventEnd(event: cc.Event.EventTouch){
        if (this.bShowTexting) {
            this.endTextShow();
            return;
        }
    }
}
